import { AdminSettings } from '@/components/admin/AdminSettings';
import { useSEO } from '@/hooks/useSEO';

export default function AdminSettingsPage() {
  useSEO({
    title: 'System Settings - Admin Tools',
    description: 'Configure application settings, system parameters, and administrative preferences for the chess application.',
    canonical: '/admin/settings',
    robots: 'noindex, nofollow'
  });

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 via-purple-950/95 to-slate-950 p-8">
      <div className="max-w-6xl mx-auto space-y-8">
        <div className="text-center space-y-4">
          <h1 className="text-3xl font-bold">System Settings</h1>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Configure application settings and system parameters for optimal performance.
          </p>
        </div>
        
        <AdminSettings />
      </div>
    </div>
  );
}